/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { tokens } from '@/theme';

export const sectionCardStyle = {
  marginBottom: '24px',
  border: `1px solid ${tokens.color.border.borderDefault}`,
  borderRadius: '8px',
  padding: '16px',
  backgroundColor: tokens.color.surface.surfaceDefault,
} as const;

export const sectionHeaderStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  marginBottom: '16px',
} as const;

export const sectionIconStyle = {
  fontSize: '16px',
  color: tokens.color.text.textDefault,
} as const;

export const sectionTitleStyle = {
  fontSize: '16px',
  fontWeight: 600,
} as const;

export const statusBadgeStyle = {
  padding: '2px 8px',
  borderRadius: '4px',
  fontSize: '11px',
  fontWeight: 600,
  textTransform: 'uppercase' as const,
};

export const enabledBadgeStyle = {
  ...statusBadgeStyle,
  backgroundColor: tokens.color.green.green01,
  color: tokens.color.green.green07,
} as const;

export const disabledBadgeStyle = {
  ...statusBadgeStyle,
  backgroundColor: tokens.color.orange.orange01,
  color: tokens.color.orange.orange07,
} as const;

export const blueBadgeStyle = {
  ...statusBadgeStyle,
  backgroundColor: tokens.color.blue.blue01,
  color: tokens.color.blue.blue07,
} as const;

export const inkBadgeStyle = {
  ...statusBadgeStyle,
  backgroundColor: tokens.color.ink.ink01,
  color: tokens.color.ink.ink07,
} as const;

export const rulesTextStyle = {
  fontSize: '13px',
  color: tokens.color.text.textSubtle,
  marginBottom: '12px',
  display: 'block',
} as const;

export const actorGroupLabelStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  padding: '4px 0',
} as const;

export const actorGroupNameStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
} as const;

export const actorNameStyle = {
  fontWeight: 600,
  fontSize: '13px',
} as const;

export const actorTypeBadgeStyle = {
  padding: '1px 6px',
  borderRadius: '3px',
  fontSize: '9px',
  fontWeight: 600,
  textTransform: 'uppercase' as const,
  backgroundColor: tokens.color.blue.blue01,
  color: tokens.color.blue.blue07,
} as const;

export const rulesCountBadgeStyle = {
  padding: '1px 6px',
  borderRadius: '3px',
  fontSize: '9px',
  fontWeight: 600,
  backgroundColor: tokens.color.ink.ink01,
  color: tokens.color.ink.ink07,
} as const;

export const rulesContainerStyle = {
  display: 'flex',
  flexDirection: 'column' as const,
  gap: '4px',
  marginTop: '8px',
} as const;

export const ruleItemStyle = {
  padding: '6px 10px',
  backgroundColor: tokens.color.surface.surfaceLow,
  borderRadius: '4px',
  border: `1px solid ${tokens.color.border.borderSubtle}`,
  fontSize: '11px',
} as const;

export const ruleHeaderStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '3px',
} as const;

export const ruleActionsStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
} as const;

export const allowActionStyle = {
  padding: '1px 4px',
  borderRadius: '2px',
  fontSize: '9px',
  fontWeight: 600,
  textTransform: 'uppercase' as const,
  backgroundColor: tokens.color.green.green01,
  color: tokens.color.green.green07,
} as const;

export const denyActionStyle = {
  padding: '1px 4px',
  borderRadius: '2px',
  fontSize: '9px',
  fontWeight: 600,
  textTransform: 'uppercase' as const,
  backgroundColor: tokens.color.red.red01,
  color: tokens.color.red.red07,
} as const;

export const capabilityTextStyle = {
  fontSize: '9px',
  color: tokens.color.text.textSubtle,
} as const;

export const ruleIdStyle = {
  fontSize: '9px',
  color: tokens.color.text.textSubtle,
  fontFamily: 'DM Mono',
} as const;

export const resourcePathStyle = {
  fontSize: '12px',
  fontFamily: 'DM Mono',
  color: tokens.color.text.textSubtle,
  lineHeight: '1.4',
} as const;

export const engineItemStyle = {
  padding: '12px',
  backgroundColor: tokens.color.surface.surfaceLow,
  borderRadius: '6px',
  border: `1px solid ${tokens.color.border.borderSubtle}`,
} as const;

export const engineHeaderStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
} as const;

export const engineNameStyle = {
  fontWeight: 600,
  fontSize: '14px',
} as const;

export const enginesListStyle = {
  display: 'flex',
  flexDirection: 'column' as const,
  gap: '8px',
} as const;

export const generalPanelStyle = {
  fontFamily: 'DM Mono',
  fontSize: '12px',
  backgroundColor: tokens.color.surface.surfaceLow,
  padding: '8px',
  borderRadius: '4px',
} as const;

export const emptyStateCardStyle = {
  textAlign: 'center' as const,
  padding: '32px',
} as const;

export const configOverviewTitleStyle = {
  fontSize: '18px',
  fontWeight: 600,
  color: tokens.color.text.textDefault,
} as const;

export const previewTextStyle = {
  fontFamily: 'DM Mono',
  fontSize: '12px',
  color: tokens.color.text.textSubtle,
} as const;
